import React from 'react';
import styled from 'styled-components';
import { getHazardRiskLevel } from '../Hazard.helpers';
import {
  HazardSeverity,
  HazardProbability,
  HazardRisk,
  HazardSeverityLabel,
  HazardProbabilityLabel
} from '../Hazard.interface';
import environment from '../../../environments';

const isBasicOptions = environment.hazardConfig?.isBasicOptions;

const colors = { severe: isBasicOptions ? '#f44336' : '#ffc107' };

export const HazardSeverityStyles: Record<keyof typeof HazardSeverity, string> =
  {
    Negligible: 'color: #4caf50; border-color: #4caf50;',
    Marginal: 'color: #4caf50; border-color: #4caf50;',
    Moderate: 'color: #ffc107; border-color: #ffc107;',
    Severe: `color: ${colors.severe}; border-color: ${colors.severe};`,
    Catastrophic: 'color: #f44336; border-color: #f44336;'
  };

export const HazardProbabilityStyles: Record<
  keyof typeof HazardProbability,
  string
> = {
  Improbable: 'color: #4caf50; border-color: #4caf50;',
  Remote: 'color: #4caf50; border-color: #4caf50;',
  Occasional: 'color: #ffc107; border-color: #ffc107;',
  Probable: 'color: #ffc107; border-color: #ffc107;',
  Frequent: 'color: #f44336; border-color: #f44336;'
};

export const HazardRiskStyles: { [key: string]: string } = Object.freeze({
  VeryLow: 'color: #4caf50; border-color: #4caf50;',
  Low: 'color: #4caf50; border-color: #4caf50;',
  Medium: 'color: #ffc107; border-color: #ffc107;',
  High: 'color: #f44336; border-color: #f44336;'
});

export interface StyledPillProps {
  value: number;
  type: string;
}

const StyledPill = styled.div<StyledPillProps>`
  width: 110px;
  border-radius: 4px;
  border-width: 2px;
  border-style: solid;
  text-align: center;
  ${({ value, type }) => {
    switch (type) {
      case 'severity':
        return HazardSeverityStyles[
          HazardSeverityLabel[
            value as HazardSeverity
          ] as keyof typeof HazardSeverity
        ];
      case 'probability':
        return HazardProbabilityStyles[
          HazardProbabilityLabel[
            value as HazardProbability
          ] as keyof typeof HazardProbability
        ];
      case 'risk':
        return HazardRiskStyles[
          HazardRisk[value] as keyof typeof HazardSeverity
        ];
    }
  }}
`;

export interface HazardPillProps {
  value: number;
  type: string;
}

export const HazardPill: React.FC<HazardPillProps> = ({ value, type }) => {
  let riskValue: HazardPillProps['value'] = value;
  if (type === 'risk') {
    riskValue = getHazardRiskLevel(value);
  }
  return (
    <StyledPill
      value={type === 'risk' ? riskValue : value}
      type={type}
    >{`${value} - ${
      type === 'severity'
        ? HazardSeverityLabel[value as HazardSeverity]
        : type === 'probability'
        ? HazardProbabilityLabel[value as HazardProbability]
        : HazardRisk[riskValue]
    }`}</StyledPill>
  );
};

export default HazardPill;
